import React from 'react';
import { faUsers } from '@fortawesome/pro-solid-svg-icons';

import PageHeader from 'components/page_header';

import SvnHowToLink from '../svn_how_to_link';
import MergeButton from './merge_button';

export default class DuplicatesPageHeader extends React.Component {
  render() {
    return (
      <PageHeader
        iconDescription="Manage your contact database"
        iconName={faUsers}
        iconSize="lg"
        iconText="Contacts"
        iconType="icon"
      >
        <div className="d-none d-md-inline-block">
          <SvnHowToLink className="me-4" />
          <MergeButton />
        </div>
      </PageHeader>
    );
  }
}
